/* eslint-disable-next-line import/no-unassigned-import, unicorn/no-unnecessary-polyfills -- polyfill by design */
import 'core-js/actual';
import { createRoot } from 'react-dom/client';
import ReactModal from 'react-modal';
import moengage from '@moengage/web-sdk';
import App from './App';

// Initialize MoEngage
moengage.initialize({
  app_id: '5RUAJKS3YPXDQTFMZTEOJGD8',
  cluster: 'dc_1',
  useLatest: true,
  debug_logs: 1
});

const app = document.querySelector('#app');
const root = app && createRoot(app);
ReactModal.setAppElement('#app');
root?.render(
  <App />
);
